
import Modal from "../Modal"
import AppButton from "../AppButton"
import ToggleButton from "../ToggleButton"
import Article from "../Article"

export default {
  name: `CookieModal`,
  components: {
    Modal,
    AppButton,
    ToggleButton,
    Article
  },
  props: {
    selectedCookies: {
      type: Array,
      default: () => []
    },
    isModalOpen: {
      type: Boolean,
      default: false
    },
    modalTitle: {
      type: String,
      default: "Cookie preferences"
    },
    modalSubTitle: {
      type: String,
      default: "How do we categorise cookies?"
    },
    acceptButton: {
      type: String,
      default: "Accept All"
    },
    saveButton: {
      type: String,
      default: "Save My Preferences"
    },
    modalDescription: {
      type: Object,
      default: () => ({})
    },
    necessaryDescription: {
      type: Object,
      default: () => ({})
    },
    performanceDescription: {
      type: Object,
      default: () => ({})
    },
    functionalDescription: {
      type: Object,
      default: () => ({})
    },
    advertisingDescription: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectorData: [
        {
          label: "Strictly necessary cookies (always on)",
          id: "necessary",
          value: true,
          disabled: true,
          description: this.necessaryDescription
        },
        {
          label: "Performance cookies",
          id: "performance",
          value: false,
          disabled: false,
          description: this.performanceDescription
        },
        {
          label: "Functional cookies",
          id: "functional",
          value: false,
          disabled: false,
          description: this.functionalDescription
        },
        {
          label: "Advertising cookies",
          id: "advertising",
          value: false,
          disabled: false,
          description: this.advertisingDescription
        }
      ]
    }
  },
  watch: {
    selectedCookies: {
      handler(selectedCookies) {
        if (selectedCookies.length) {
          this.selectorData.map(item => {
            let matchingData = selectedCookies.find(data => item.id === data.id)
            if (matchingData) {
              item.value = matchingData.value
            }
            return item
          })
        }
      },
      deep: true
    }
  },
  methods: {
    handleCloseModal() {
      this.$emit("closeModal")
    },
    submitPreferences(isAcceptAll) {
      let selectorValues = this.selectorData.map(data => {
        return {
          id: data.id,
          value: isAcceptAll ? true : data.value
        }
      })
      this.$emit("saveCookieChoice", selectorValues)
    }
  }
}
